var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 17,
    viewBox: "0 0 68 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5441 4.66123C68.4477 9.85429 63.7806 15.0036 57.12 16.1625C50.4593 17.3214 44.3273 14.051 43.4238 8.85799C42.5202 3.66493 46.3786 2.28314 53.0393 1.12423C59.6999 -0.0346678 66.6406 -0.531831 67.5441 4.66123Z",
    fill: "#0CC5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.593838 4.66123C-0.309716 9.85429 4.35733 15.0036 11.018 16.1625C17.6786 17.3214 23.8106 14.051 24.7142 8.85799C25.6177 3.66493 21.7593 2.28314 15.0987 1.12423C8.43803 -0.0346678 1.49739 -0.531831 0.593838 4.66123Z",
    fill: "#0CC5FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes);
export default __webpack_public_path__ + "static/media/eyes.5b19635d65f33546479227e329e7811f.svg";
export { ForwardRef as ReactComponent };